import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id D31C18C1-776C-4444-9A12-F2BD366CF929
 * name knife-military
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/knife-military.svg
 * tags
 * - Gaming / RPG 
 */
export const KnifeMilitaryIcon = createSvgIcon(<><path d="M22,2L17.39,3.75L10.46,10.68L14,14.22L20.92,7.29C22.43,5.78 22,2 22,2M8.33,10L6.92,11.39L8.33,12.8L2.68,18.46L6.21,22L11.87,16.34L13.28,17.76L14.7,16.34L8.33,10Z" /></>, 'KnifeMilitaryIcon');
export default KnifeMilitaryIcon